export const priceUnits = [
  { value: 'IRR', label: 'ریال' },
  { value: 'USD', label: 'دلار' },
  { value: 'PKR', label: 'روپیه' },
  { value: 'AFN', label: 'افغانی' },
]
